import React, { useState } from 'react';
import Input from '@/components/General/inputs/Input';
import { useMutation } from '@tanstack/react-query';
import { saveMethod } from '@/data/contributions';
import { useLocalSearchParams, useRouter } from 'expo-router';
import Toast from 'react-native-toast-message';
import { useQueryClient } from '@tanstack/react-query';
import { Query } from '@/utils/react-query/Queries';
import { QueryKeys } from '@/utils/react-query/QueryKeys';
import { useEffect } from 'react';
import ModalWrapper from '@/components/General/ModalWrapper';

const MethodForm = () => {
  const [methodDetails, setMethodDetails] = useState('');
  const { id } = useLocalSearchParams()

  const router = useRouter()

  /*** Queries ***/
  const queryClient = useQueryClient()
  const { data: methodToEdit } = Query.contributionMethods.byId({id: id, options: {enabled: !!id}})

  useEffect(() => {
      if(methodToEdit && id){
          setMethodDetails({...methodToEdit, originalValues: methodToEdit})
      }
  }, [methodToEdit, id])

  const saveMethodMutation = useMutation({
      mutationFn: saveMethod,
      onSuccess: () => {
          queryClient.invalidateQueries({queryKey: QueryKeys.contributionMethods.all()});
          router.canGoBack() ? router.back() : router.replace("/")
          setTimeout(() => Toast.show({ type: 'success', text2: `Method ${id ? "updated" : "created"} successfully!` }), 100);
      },
      onError: () => {
          setTimeout(() => Toast.show({ type: 'error', text2: `Failed to ${id ? "update" : "create"} method!` }), 100);
      },
  });

  return (
    <ModalWrapper title={id ? "Edit Method" : "New Method"} loading={saveMethodMutation.isPending} onConfirm={() => {
        const { originalValues, ...clean } = methodDetails;
        saveMethodMutation.mutate({name: clean?.name, detailName: clean?.detailName, originalValues})
    }} confirmText={id ? "Update" : "Create"}> 
        <Input
            isNotOnSurface
            title="Method Name"
            value={methodDetails?.name}
            onUpdate={(new_value) => {
                setMethodDetails({
                    ...methodDetails,
                    name: new_value
                })
            }}
            placeholder="e.g., Credit Card, Check"
        />
        <Input
            title="Transaction Detail Name"
            value={methodDetails?.detailName}
            onUpdate={(new_value) => {
                setMethodDetails({
                    ...methodDetails,
                    detailName: new_value
                })
            }}
            helpText="When selecting this method on a transaction, a field with this name will be added to the transaction form."
            placeholder="e.g., Last 4 Digits, Check Number"
        />
    </ModalWrapper>
  );
};

export default MethodForm;
